export enum StatusBusinessTripFormEnum {
    ON_TIME = 'OnTime',
    LATE_CHECK_IN = 'LateCheckIn',
    LATE_CHECK_OUT = 'LateCheckOut',
    LATE_BOTH = 'LateBoth',
    UNCHECKED_OUT = 'UncheckedOut',
    NEW = 'New',
}
